import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=85cbb79a&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85cbb79a')) {
      api.createRecord('85cbb79a', component.options)
    } else {
      api.reload('85cbb79a', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=85cbb79a&", function () {
      api.rerender('85cbb79a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HKG2OPqc1T14/JS/comp/openstreetmap.vue"
export default component.exports